import { ColumnType } from 'antd/es/table'
import dayjs from 'dayjs'

import { FeedingType, NewbornItemDto } from 'src/api/requests'
import { GenderShortMap } from 'src/features/persons/utils'
import { dayMonthYearBackSlash } from 'src/libs'
import { useLocales } from 'src/locales'

export const useNewBornColumns = () => {
  const { t } = useLocales()

  const feedingTypeOptions = Object.entries(FeedingType).map(([_, value]) => ({
    value,
    label: t(`pregnancy.feeding_types.${value}`)
  }))

  const columns: ColumnType<NewbornItemDto>[] = [
    {
      key: 'firstName',
      dataIndex: 'firstName',
      title: t('form.first_name')
    },
    {
      key: 'lastName',
      dataIndex: 'lastName',
      title: t('form.last_name')
    },
    {
      key: 'birthDate',
      title: `${t('pregnancy.birth_date')}`,
      render: (_, { birthDate }) =>
        birthDate ? dayjs(birthDate).format(dayMonthYearBackSlash) : '-'
    },
    {
      key: 'feedingType',
      title: t('pregnancy.feeding_type'),
      render: (_, { feedingType }) =>
        feedingTypeOptions?.find((option) => option?.value === feedingType)
          ?.label ?? '-'
    },
    {
      key: 'status',
      title: t('pregnancy.newborn_status'),
      render: (_, { status }) =>
        t(`pregnancy.newborn_statuses.${status}`) || '-'
    },
    {
      key: 'gender',
      title: t('form.gender'),
      render: (_, { gender }) => (gender ? GenderShortMap[gender] : '-')
    },
    {
      key: 'currentWeightInKg',
      title: t('pregnancy.current_weight'),
      render: (_, { currentWeightInKg }) =>
        currentWeightInKg !== null ? `${currentWeightInKg} kg` : '-'
    },
    {
      key: 'currentHeightInCm',
      title: t('pregnancy.current_height'),
      render: (_, { currentHeightInCm }) =>
        currentHeightInCm !== null ? `${currentHeightInCm} cm` : '-'
    }
  ]

  return {
    columns
  }
}
